<div class="ai-advice-widget" (click)="openAiChatModal()">
    <div class="ai-advice-widget__header">
        <div class="ai-advice-widget__header-content">
            <div class="ai-advice-widget__title">{{ title }}</div>
            <ng-container *ngIf="isEditMode">
                <div (click)="toggleSizeDropdown(index, $event)" cdkOverlayOrigin #editTrigger="cdkOverlayOrigin"
                    class="ai-advice-widget__icon-container">

                    <div class="ai-advice-widget__icon"><img src="assets/icons/widget/pencil.svg"
                            alt="AI Advice Widget">
                    </div>
                </div>
                <!-- Size Dropdown -->
                <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
                    [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize"
                    [removeWidget]="removeWidget" [toggleSizeDropdown]="toggleSizeDropdown">
                </app-widget-edit>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                    alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
            </ng-container>
        </div>

    </div>
    <div class="ai-advice-widget__body">
        <div class="ai-advice-widget__content">
            <div class="ai-advice-widget__avatar-section">
                <img src="assets/icons/widget/star-06.svg" alt="AI Advice Widget">
                <div class="ai-advice-widget__avatar-info">
                    <div class="ai-advice-widget__avatar-name">{{ aiName }}</div>
                </div>
            </div>
            <div class="ai-advice-widget__message-section">
                <div class="ai-advice-widget__message">{{ message }}</div>
            </div>
        </div>

        <div class="search-btn">
            <div
                style="text-align: center; color: var(--color-primary1, black); font-size: 14px; font-family: Switzer; font-weight: 600; line-height: 16px; letter-spacing: 0.07px; word-wrap: break-word">
                Search</div>
            <div style="width: 20px; height: 20px; position: relative; transform-origin: top left; overflow: hidden">
                <img class="ai-chat-widget-right-icon" src="assets/icons/arrow-right.svg" alt="arrow-right" width="12"
                    height="8">
            </div>
        </div>
    </div>
</div>